module.exports = __webpack_public_path__ + "img/wx_follow_bg1.0e9c73fe.png";